"use strict";

(function () {
  'use strict';

  angular.module('lr.Settings').factory('DeviceAdminFactory', DeviceAdminFactory);
  DeviceAdminFactory.$inject = ['api', '$http', '$window', '$uibModal'];
  /* @ngInject */

  function DeviceAdminFactory(api, $http, $window, $uibModal) {
    /**
     * @returns {DeviceAdmin}
     * @constructor
     */
    var DeviceAdmin = function DeviceAdmin(adminCustDataID, apiProxy) {
      this.hasData = true;
      this.showContainer = false;
      this.isLoading = false;
      this.hasError = false;
      this.errorText = '';
      this.errorMsg = 'An error has occurred';
      this.data = [];
      this.devicesTable = {};
      this.pageDataDropdownName = 'js-device-dropdown';
      this.adminCustDataID = adminCustDataID;
      this.rtmBaseUrl = apiProxy;
      this.servicesBaseURL = apiProxy;
      return this;
    };
    /**
     *
     * @returns {DeviceAdmin}
     */


    DeviceAdmin.prototype.rescanUpdateDevices = function () {
      var _this = this;

      _this.isLoading = true;
      _this.hasError = false;
      $http.post(this.rtmBaseUrl + '/Admin/PointCentral/Devices/Rescan', {
        AutomationServiceTypeID: 2
      }).success(function () {
        _this.devicesTable.fnDraw();
      }).error(function (data) {
        _this.displayError(data.statusText);

        _this.isLoading = false;
      });
      return this;
    };
    /**
     *
     * @returns {DeviceAdmin}
     */


    DeviceAdmin.prototype.importProperties = function () {
      var _this = this;

      _this.isLoading = true;
      _this.hasError = false;
      $http.post(this.rtmBaseUrl + '/Admin/LiveRez/Properties/Import', {
        serviceType: 0
      }).success(function () {
        _this.devicesTable.fnDraw();
      }).error(function (data) {
        _this.displayError(data.statusText);

        _this.isLoading = false;
      });
      return this;
    };
    /**
     *
     * @param msg
     * @returns {DeviceAdmin}
     */


    DeviceAdmin.prototype.displayError = function (msg) {
      this.hasError = true;
      this.errorText = this.errorMsg + ' : ' + msg;
      return this;
    };
    /**
     *
     */


    DeviceAdmin.prototype.getPropertiesForPartner = function () {
      var _this = this;

      $http.get(_this.servicesBaseURL + '/Property/List/Dropdown').success(function (data) {
        _this.data = data;

        _this.initTable();
      }).error(function (data) {
        _this.displayError(data.statusText);
      });
    };
    /**
     *
     * @param pageDataID
     * @param automationHubID
     * @param automationServiceTypeID
     */


    DeviceAdmin.prototype.saveDeviceChanges = function (pageDataID, automationHubID, automationServiceTypeID) {
      var _this = this;

      var sendData = {
        adminCustDataID: _this.adminCustDataID,
        automationHubID: automationHubID,
        pageDataID: pageDataID,
        automationServiceTypeID: automationServiceTypeID || 2
      };
      $http.post(this.rtmBaseUrl + '/Automation/Hub/UpdateAssignedProperty', sendData).success(function () {
        _this.isLoading = false;

        _this.devicesTable.fnDraw();
      }).error(function (data) {
        _this.isLoading = false;

        _this.displayError(data.statusText);
      });
    };
    /**
     *
     * @param row
     * @param data
     * @returns {*|jQuery}
     */


    DeviceAdmin.prototype.createDropDown = function (pid, data) {
      var changeLink = $('<a />').text('change').addClass('property-change-link').addClass(this.pageDataDropdownName).attr('data-pid', pid).attr('data-automationhubid', data.automationHubID).attr('data-automationservicetypeid', data.automationServiceTypeID);

      if (pid) {
        return $('<div>').append(pid + ' ').append(changeLink).html();
      } else {
        changeLink.addClass('btn btn-small btn-primary');
        changeLink.text('Set Property');
        return $('<div>').append(changeLink).html(); // var dropDown = $('<select />')
        //   .addClass(this.pageDataDropdownName)
        //   .attr('data-automationhubid', data.automationHubID)
        //   .attr('data-automationservicetypeid', data.automationServiceTypeID);
        // var option = '';
        // var _this = this;
        // dropDown
        //   .append($('<option />', { value: null, text: 'Unassigned' }))
        //   .addClass('lr-device-dropdown');
        // for (var i = 0; i < _this.data.length; i++) {
        //   option = $('<option />', {value: _this.data[i].value, text: _this.data[i].name});
        //   if (_this.data[i].name === pid) {
        //     option.attr('selected', 'selected');
        //   }
        //   option.appendTo(dropDown);
        // }
        //return $('<div>').append(dropDown.clone()).html();
      }
    };
    /**
     *
     */


    DeviceAdmin.prototype.initTable = function () {
      var _this = this;

      _this.devicesTable = $('#devicesTable').dataTable({
        'bJQueryUI': false,
        'bProcessing': true,
        'bServerSide': true,
        'bPaginate': false,
        'bLengthChange': false,
        'bInfo': true,
        'bFilter': false,
        'bAutoWidth': false,
        'bSortClasses': false,
        'sAjaxSource': this.rtmBaseUrl + '/Automation/Device/List/DataTable',
        'fnServerParams': function fnServerParams(aoData) {
          aoData.push({
            'name': 'adminCustDataID',
            'value': _this.adminCustDataID
          });
        },
        'fnServerData': function fnServerData(sSource, aoData, fnCallback) {
          $.ajax({
            'dataType': 'json',
            'type': 'POST',
            xhrFields: {
              withCredentials: true
            },
            headers: {
              "Authorization": $window.sessionStorage.token
            },
            'url': sSource,
            'data': aoData,
            'success': function success(data) {
              fnCallback(data);
            },
            'error': function error(data) {
              _this.isLoading = false;

              _this.displayError(data.statusText);
            }
          });
        },
        'fnInitComplete': function fnInitComplete() {
          _this.isLoading = false;

          if (parseInt(_this.devicesTable.fnSettings().fnRecordsDisplay()) <= 0) {
            _this.hasData = false;
            _this.showContainer = false;
          } else {
            _this.hasData = true;
            _this.showContainer = true;
          }
        },
        'fnDrawCallback': function fnDrawCallback(oSettings) {
          /* Need to redo the counters if filtered or sorted */
          for (var i = 0, iLen = oSettings.aiDisplay.length; i < iLen; i++) {
            var num = oSettings._iDisplayStart + i + 1;
            $('td:eq(0)', oSettings.aoData[oSettings.aiDisplay[i]].nTr).html(num);
          }

          $('.' + _this.pageDataDropdownName).on('click', function () {
            var $that = $(this);
            var pid = $that.data().pid;
            var automationhubid = $that.data().automationhubid;
            var modalInstance = $uibModal.open({
              templateUrl: 'app/settings/property-select-modal.html',
              controller: function controller($scope, modalData, $uibModalInstance) {
                if (modalData.pid) {
                  for (var i = 0; i < modalData.properties.length; i++) {
                    if (modalData.properties[i].name === modalData.pid) {
                      $scope.selectedProperty = modalData.properties[i];
                    }
                  }
                }

                $scope.properties = modalData.properties;

                $scope.select = function () {
                  $uibModalInstance.close($scope.selectedProperty);
                };

                $scope.cancel = function () {
                  $uibModalInstance.close();
                };
              },
              resolve: {
                modalData: function modalData() {
                  return {
                    pid: pid,
                    properties: _this.data
                  };
                }
              }
            });
            modalInstance.result.then(function (property) {
              if (property && property.value) {
                _this.saveDeviceChanges(property.value, automationhubid);
              }
            }, function () {// no action
              // console.log('cancelled');
            });
          });
        },
        'aoColumns': [{
          'mData': null,
          'bSortable': false,
          'sClass': 'dtCenterColumn',
          'sWidth': '5%'
        }, {
          'mData': 'hubName',
          'bSortable': false,
          'sClass': 'dtLeftColumn',
          'sWidth': '15%'
        }, {
          'mData': 'providerHubID',
          'bSortable': false,
          'sClass': 'dtCenterColumn',
          'sWidth': '15%'
        }, {
          'mData': 'providerDeviceID',
          'bSortable': false,
          'sClass': 'dtCenterColumn',
          'sWidth': '15%'
        }, {
          'mData': 'deviceName',
          'bSortable': false,
          'sClass': 'dtLeftColumn',
          'sWidth': '15%'
        }, {
          'mData': 'pid',
          'bSortable': false,
          'sClass': 'dtLeftColumn',
          'sWidth': '25%',
          'mRender': function mRender(row, type, data) {
            return _this.createDropDown(row, data);
          }
        }]
      });
    };

    return {
      generate: function generate(args) {
        return new DeviceAdmin(args.adminCustDataID, api.proxy);
      }
    };
  }
})();